import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['panel'];
  static values = { index: Number };

  indexValueChanged() {
    this.hideCurrent();
  }

  change(event) {
    event.preventDefault();
    this.indexValue = event.target.dataset.hideIndex;
  }

  hideCurrent() {
    this.panelTargets.forEach((panel, index) => {
      const isHidden = index === this.indexValue;
      panel.hidden = isHidden;
      panel.setAttribute('aria-hidden', isHidden.toString());
    });
  }
}
